require('./brokerConvenienceMiFIDTestIncoherenceModal.scss')

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @componets
const OKModal = require('components/commons/OKModal/OKModal');
const { formatDate } = require('utilities/dateHelper');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @constants
const { DATE_FORMAT_SLASHED_ES, DATE_FORMAT } = require('constants/index');


const CLASS_NAME = 'broker-incoherence-modal';

class BrokerConvenienceMiFIDTestIncoherenceModal extends React.Component {
    buildContent(){
        const { modalContent, immBrokerConsultMiFID, finishStep } =  this.props;
        const date = immBrokerConsultMiFID.get('fecha') && (
            <span>
                {formatDate(
                    moment(immBrokerConsultMiFID.get('fecha'), DATE_FORMAT_SLASHED_ES),
                    DATE_FORMAT
                )}
            </span>
        );
        const verificarionQuestion = finishStep
            ? formatText('broker-convenienceMifidTestIncoherenceModalVerificarionQuestionFinishContent')
            : formatText('broker-convenienceMifidTestIncoherenceModalVerificationQuestionContent');
        return(
            <div className={`${CLASS_NAME}`}>
                <p className={`${CLASS_NAME}__date`}>
                    <FormattedTextWithComponents
                        value="broker-convenienceMifidTestIncoherenceModalDateContent"
                        injectedComponents ={[
                            date
                        ]}
                    />
                </p>
                <div className={`${CLASS_NAME}__answered`}>
                    {modalContent}
                </div>
                <p className={`${CLASS_NAME}__question`}>
                    {verificarionQuestion}
                </p>
            </div>
        );
    }

    render(){
        const {
            checkIncoherences,
            continueWithIncoherences,
            showModal,
            finishStep
        } =  this.props;
        const content = this.buildContent();
        const secondaryButtonText = finishStep
            ? formatText('broker-convenienceMifidTestIncoherenceModalFinishQuestionButton')
            : formatText('broker-convenienceMifidTestIncoherenceModalNextQuestionButton');
        return(
            <OKModal
                isOpen={showModal}
                title={formatText('broker-convenienceMifidTestIncoherenceModalTitle')}
                titleAlignment="center"
                content={content}
                primaryButtonText={formatText('broker-convenienceMifidTestIncoherenceModalVerificationButton')}
                secondaryButtonText={secondaryButtonText}
                footerType="navigation"
                size="medium"
                onCloseCallback={checkIncoherences}
                onPrimaryButtonClick={checkIncoherences}
                onSecondaryButtonClick={continueWithIncoherences}
            />
        );
    }
}

BrokerConvenienceMiFIDTestIncoherenceModal.PropTypes = {
    showModal: PropTypes.bool.isRequired,
    modalContent: PropTypes.object.isRequired,
    checkIncoherences: PropTypes.func.isRequired,
    continueWithIncoherences: PropTypes.func.isRequired,
    finishStep: PropTypes.bool,
    immBrokerConsultMiFID: PropTypes.object.isRequired,
}

BrokerConvenienceMiFIDTestIncoherenceModal.defaultProp = {
    finishStep: false,
}

module.exports = BrokerConvenienceMiFIDTestIncoherenceModal;